
export default class ChatConversationContextDTO {
    constructor(json) {
        this.id = json["id"];
        this.resourceType = json["resource-type"];
        this.resourceTypeDisplay = json["resource-type-display"];
        this.resourceId = json["resource-id"];
    }
}